export const FormUtils = {
  generateFormData: (formValues: any, fileProps: string[] = []) => {
    const fd: FormData = new FormData();

    fileProps?.forEach((prop: string) => {
      console.log('fajl', prop, formValues[prop]);
      fd.append(prop, formValues[prop]);
      delete formValues[prop];
    });

    fd.append('data', JSON.stringify(formValues));

    return fd;
  },
};
